import React from "react";
import CreditScoreTracker from "./CreditScoreTracker";
import { ezsServiceIds, idfServiceIds } from "../../../config/UserServicesList";
import { useAreServicesActive, useAreServicesAndFeatureActive } from "../../../util/CommonServices";

interface IProps {
    isIDFUser: boolean;
}

const CreditTrackerDashboard: React.FunctionComponent<IProps> = (props) => {
    // Start Active service base UI Display Logic
    const ids = [
        idfServiceIds.creditScoreMonitoring,
        idfServiceIds.threeBureauCreditScores,
        idfServiceIds.transUnionCreditScore,
        ezsServiceIds.quarterlyCreditScore,
        ezsServiceIds.tuDailyCreditScore,
        ezsServiceIds.tuMonthlyCreditScore,
        ezsServiceIds.tuQuarterlyCreditScore,
        ezsServiceIds.tuAnnualCreditScore,
        ezsServiceIds.tuCanadaCreditScore,
        ezsServiceIds.monthlyCreditScore,
        ezsServiceIds.tuCreditScoreTracker,
        ezsServiceIds.tuCanadaCreditScoreTracker,
        ezsServiceIds.expMonthlyCreditScoreTracker,
    ];

    const creditScoreTrackerIds = [idfServiceIds.creditScoreTracker];

    let isCreditScoreTrackerActive = useAreServicesAndFeatureActive(ids, ["Product.CreditScoreTracker"]);
    const idfCreditTrackerActive = useAreServicesActive(creditScoreTrackerIds);

    if (props.isIDFUser) {
        isCreditScoreTrackerActive = idfCreditTrackerActive;
    } else {
        isCreditScoreTrackerActive = isCreditScoreTrackerActive;
    }

    return <React.Fragment>{isCreditScoreTrackerActive && <CreditScoreTracker isIDFUser={props.isIDFUser} source={"dashboard"} />}</React.Fragment>;
};

export default CreditTrackerDashboard;
